import { render } from "./InformationRight.vue?vue&type=template&id=d60c1260"
import script from "./InformationRight.vue?vue&type=script&lang=js"
export * from "./InformationRight.vue?vue&type=script&lang=js"

import "./InformationRight.vue?vue&type=style&index=0&id=d60c1260&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__